import styled from 'styled-components';

import { AiFillDelete } from "react-icons/ai";

export const Container = styled.div``;

export const Header = styled.div`

    height: 100px;

    display: flex;
    flex-direction: row;

    justify-content: space-between;

    margin-top: 20px;

`;

export const LogoContainer = styled.div`

    display: flex;
    flex-direction: row;

    gap: 20px;

`;

export const BotaoContainer = styled.div`

    display: flex;
    flex-direction: column-reverse;

`;

export const Botao = styled.button`
    height: 50px;
    display: flex;
    flex-direction: row;

    gap: 10px;

    margin-bottom: 5px;

    align-items: center;
    text-align: center;
    border-radius: 10px;

    transition: opacity .3s;
    &:hover {
        opacity: .7;
        background-color: #F0E68C;
    }
`;

export const ListContainer = styled.div`
    margin: 40px;

`;

export const ListHeader = styled.ul`

    text-align: center;
    
`;

export const ListContent = styled.ul`

    > li {
        border-radius: 10px;
        border: 1px solid blue;
        
        display: grid;
        grid-template-columns: 0.5fr 3fr 3fr 0.75fr 0.75fr 0.75fr;
        
        margin-bottom: 10px;

        .li-text-box {
            margin: auto;
            text-align: center;
        }

        .li-button-container {
            margin: auto;
            justify-self: center;

            

            > button {
                height: 50px;
                display: flex;
                flex-direction: row;
                gap: 10px;
                margin-bottom: 5px;
                align-items: center;
                text-align: center;
                border-radius: 10px;
                cursor: pointer;

                transition: opacity .3s;
                &:hover {
                    opacity: .7;
                    background-color: #F0E68C;
                }
            }
        }

    }

`;

export const ListPagination = styled.div``;

export const AiFillDeleteIcon = styled(AiFillDelete)`
    width: 20px;
    height: 20px;
    color: black;
`;
